import { FC } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import { useTranslation } from '../i18n/useTranslation';

interface JoinPromptCardProps {
  organizationName: string;
  submitting: boolean;
  onJoin: () => void;
  onCancel: () => void;
}

const JoinPromptCard: FC<JoinPromptCardProps> = ({
  organizationName,
  submitting,
  onJoin,
  onCancel,
}) => {
  const t = useTranslation();
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      bgcolor="#f8f8fa"
      p={3}
    >
      <Card
        sx={{
          maxWidth: 480,
          width: '100%',
          p: 5,
          border: '1px solid rgba(0,0,0,0.08)',
          borderRadius: '12px',
          textAlign: 'center',
        }}
      >
        <Box
          sx={{
            width: 64,
            height: 64,
            borderRadius: '16px',
            bgcolor: 'rgba(49,103,155,0.08)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mx: 'auto',
            mb: 3,
          }}
        >
          <GroupAddIcon sx={{ fontSize: 28, color: '#31679b' }} />
        </Box>
        <Typography variant="h5" sx={{ fontWeight: 700, mb: 1.5, letterSpacing: '-0.02em' }}>
          {t('authGuard.joinPrompt.title').replace('{org}', organizationName)}
        </Typography>
        <Typography sx={{ color: 'text.secondary', lineHeight: 1.7, mb: 3 }}>
          {t('authGuard.joinPrompt.body')}
        </Typography>
        <Button
          variant="contained"
          fullWidth
          size="large"
          onClick={onJoin}
          disabled={submitting}
          sx={{ mb: 1, textTransform: 'none', py: 1.3 }}
        >
          {submitting ? (
            <CircularProgress size={20} sx={{ color: 'inherit' }} />
          ) : (
            t('authGuard.joinPrompt.requestAccess')
          )}
        </Button>
        <Button
          variant="text"
          fullWidth
          onClick={onCancel}
          disabled={submitting}
          sx={{ textTransform: 'none' }}
        >
          {t('authGuard.joinPrompt.cancel')}
        </Button>
      </Card>
    </Box>
  );
};

export default JoinPromptCard;
